<template>
  <div>
    <!-- <pre>{{ userDetails }}</pre> -->
    <v-alert v-if="loading" type="info" text>
      Carregando informações do usuário...
    </v-alert>

    <v-card outlined class="d-flex flex-wrap pa-3 rounded-lg gap-2">
      <base-avatar
        :src="userDetails?.photo || ''"
        :seed="userDetails?.id || ''"
        :size="40"
      />
      <div>
        <b class="mb-0">{{ userDetails?.name }}</b>
        <p class="mb-0 lh-1">
          {{ userDetails?.phone }} • {{ userDetails?.email }}
        </p>
      </div>
    </v-card>

    <UserPayments :user="userDetails" class="mt-4" />

    <v-btn
      @click="blockUser"
      :disabled="loadingBlock || !userDetails.active"
      color="error"
      block
      class="mt-4"
    >
      <v-icon small left>mdi-account-cancel</v-icon>
      {{ userDetails.active ? "Bloquear usuário" : "Usuário bloqueado" }}
    </v-btn>

    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between mt-4">
      <v-btn @click="$emit('close')" :disabled="loading || loadingBlock" text>
        Finalizar
      </v-btn>
      <!-- <v-btn
        @click="$emit('next')"
        :disabled="loading || loadingBlock"
        color="primary"
      >
        Próximo
      </v-btn> -->
    </div>
  </div>
</template>

<script>
import USERS from "@/services/admin/users";
import UserPayments from "../../users/components/UserPayments.vue";

export default {
  name: "ChargebackUserInfo",
  components: { UserPayments },
  props: {
    payment: {
      type: Object,
      required: true,
    },
    refund: {
      type: Object,
      required: true,
    },
    antifraud: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userDetails: null,
      loading: false,
      loadingBlock: false,
      error: null,
    };
  },
  methods: {
    async getUser() {
      try {
        if (!this.user) return;
        this.loading = true;
        this.error = null;

        const response = await USERS.getUser(this.user.id);
        this.userDetails = response.user;
      } catch (error) {
        this.error = error.message || "Erro ao buscar usuário";
      } finally {
        this.loading = false;
      }
    },
    async blockUser() {
      try {
        this.loadingBlock = true;
        await USERS.blockUser(this.userDetails.id);
        this.userDetails.active = false;
      } catch (error) {
        console.error(error);
        this.error = error.message || "Erro ao bloquear usuário";
      } finally {
        this.loadingBlock = false;
      }
    },
  },
  computed: {
    user() {
      const [ticket] = this.payment?.Ticket || [];
      if (!ticket) return null;
      return this.payment?.Payer || ticket.Owner;
    },
  },
  watch: {
    user(newVal) {
      this.getUser();
    },
  },
  mounted() {
    this.getUser();
  },
};
</script>
